<div class="home-navigation">
  <!--User Details-->
  <ng-container *ngIf="member$ | async as member">
    <div class="user-info d-flex align-items-center justify-content-between">
      <div>
        <p class="user-name mb-0" [class.user-name--club1901]="isClub1901">{{ member.FirstName }} {{ member.Surname }}</p>
        <p class="user-id mb-0">{{ 'member.id' | translate }} {{ member.ExternalRefNumber }}</p>
      </div>
      <a [routerLink]="['/rewards/wallet']" class="my-rewards-btn bg-glass d-flex align-items-center">
        <span class="material-icons me-2">qr_code_scanner</span>
        <span>{{ 'btn.wallet.rewards' | translate }}</span>
      </a>
    </div>
  </ng-container>

  <!--Club1901 Banner-->
  <ng-container *inPopulation="['Club1901']">
    <img class="club1901-banner" [src]="'1901/1901-welcome.png' | contentAssetImage" alt="club1901-welcome-banner" />
  </ng-container>

  <!--Kids Banner-->
  <ng-container *inPopulation="['Kids']">
    <ng-container *ngIf="memberDetails$ | async as memberDetails">
      <img
        *ngIf="memberDetails.kidType == KidType.AllStars"
        class="kid-banner"
        [src]="'banners/welcome-banner-allstars.png' | contentAssetImage"
        alt="welcome-banner-all-star"
      />
      <img
        *ngIf="memberDetails.kidType == KidType.Junior"
        class="kid-banner"
        [src]="'banners/welcome-banner-baller.png' | contentAssetImage"
        alt="welcome-banner-junior"
      />
    </ng-container>
  </ng-container>

  <!--Navigation-->
  <div class="nav-scroll-wrapper position-relative">
    <div class="nav-scroll" #navScroll (scroll)="onNavScroll($event)">
      <div class="nav-track">
        <a [routerLink]="['/rewards']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-icons">redeem</span>
          </div>
          <span class="nav-label">{{ 'home.nav.rewards' | translate }}</span>
        </a>
        <a [routerLink]="['/challenges']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-icons">emoji_events</span>
          </div>
          <span class="nav-label">{{ 'home.nav.challenges' | translate }}</span>
        </a>
        <a [routerLink]="['/games']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-icons">sports_esports</span>
          </div>
          <span class="nav-label">{{ 'home.nav.games' | translate }}</span>
        </a>
        <a [routerLink]="['/tv']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-symbols-outlined">animated_images</span>
          </div>
          <span class="nav-label">{{ 'home.nav.latest' | translate }}</span>
        </a>
        <a *inPopulation="['Default']" [routerLink]="['/brand']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-symbols-outlined">percent_discount</span>
          </div>
          <span class="nav-label">
            {{ 'home.nav.exclusive.offers' | translate }}
          </span>
        </a>
        <a *inPopulation="['Club1901']" [routerLink]="['/brand']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-symbols-outlined">percent_discount</span>
          </div>
          <span class="nav-label">
            {{ 'home.nav.exclusive.offers.1901' | translate }}
          </span>
        </a>
        <a *inPopulation="['Kids']" [routerLink]="['/training-zone']" [routerLinkActive]="'active'" class="nav-item">
          <div class="nav-icon-bubble bg-glass">
            <span class="material-symbols-outlined">animated_images</span>
          </div>
          <span class="nav-label">{{ 'home.nav.training.zone' | translate }}</span>
        </a>
      </div>
    </div>
    <div class="nav-fade" [class.nav-fade--hidden]="isScrollEnd"></div>
  </div>
</div>
